// -------------------------------------------------------------------------------------------------
// Import external dependencies

import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Import local dependencies

// import Foo from './app/_foo';

// -------------------------------------------------------------------------------------------------
// Import theme components

import themeCommon from './theme/_common';
import themeLazyBg from './theme/_lazyBg';
import themePageSearchModal from './theme/_pageSearchModal';
import themePageHeader from './theme/_pageHeader';
import themeContentHeader from './theme/_contentHeader';
import themeContentWithSidebar from './theme/_contentWithSidebar';
import themeBigLeaf from './theme/_bigLeaf';
import themeJumbo from './theme/_jumbo';
import themeSectorsSlider from './theme/_sectorsSlider';
import themeTopicsCatalog from './theme/_topicsCatalog';
import themeLocationsCatalog from './theme/_locationsCatalog';
import themeLocationTour from './theme/_locationTour';
import themeLocationMap from './theme/_locationMap';
import themeStaffGrid from './theme/_staffGrid';
import themeShareButton from './theme/_shareButton';
import themeSliderWithFilter from './theme/_sliderWithFilter';
import themeFormSelect from './theme/_formSelect';
import themeContactForm from './theme/_contactForm';
import themeSliderCarousel from './theme/_sliderCarousel'
import themeFloatingContactIcon from './theme/_floatingContactIcon';
import themeScrollIndicator from './theme/_scrollIndicator';
import themeHrlistSplit from './theme/_hrlist-split';
import themeNewsListView from './theme/_newsListView';
import themeVirtuelleTour from './theme/_virtuelle-tour';
import themeLazyImages from './theme/_lazyImages';
import themeContactIcon from './theme/_contactIcon';
import initTextSwitch from './theme/_textSwitch';
import themeDropdownMenuNested from './theme/_dropdownMenuNested';
import themeNavPillsOverflow from './theme/_navPillsOverflow';
import themePetrolNavigation from './theme/_petrolNavigation';
import themePushdownNonSection from './theme/_pushdownNonsection';
import themeDropzone from './theme/_dropzone';
import themeDatepicker from './theme/_datepicker';
import themeFormSubmit from './theme/_formSubmit';
import themePageHeaderSliderDisruptors from './theme/_pageHeaderSliderDisruptors';
import themeBlogCategories from './theme/_blog-categories';
import themeBlogHeader from './theme/_blog-header';
import themeBlogAjax from './theme/_blogAjax';
import themeMultiStepForm from './theme/_multiStepForm';
import themeTooltip from './theme/_tooltip';
import themeGallerySlider from './theme/_sliderGallery';
import themeWeeklyPlan from './theme/_weekly-plan';
import themeHideDateIcon from './theme/_hide-date-icon';
import dateInputs from './theme/_date-value-check';
import medatixx from './theme/_medatixx';
import datalayerTracking from './theme/data-layer/_datalayerTracking';
import cookiesDatalayerTracking from './theme/data-layer/_cookiesDatalayerTracking';
import linkSwitcher from './theme/_link-switcher';
import digiAccess from './theme/_digiaccess';

// import themeInputError from './theme/_input-error';
import counterStatistic from './theme/_counterStatistic';
import { initializePageloadRunner } from './runner-pageload';
import initializeTiles from './theme/_tiles';
import initializeModalOverlays from './theme/_modalOverlay';
import {getAssetPath} from './_util';
import LeafInfo from './theme/_leafInfo';
import {applyHyphenation} from "./theme/_hyphen";
import kirinusHeader from './theme/relaunch/_kirinusHeader';
import referFriends from './theme/refer-friends';

// -------------------------------------------------------------------------------------------------
// Load files

window.jQuery = $;

__webpack_public_path__ = getAssetPath(document.currentScript.src);

// -------------------------------------------------------------------------------------------------
// Functions

// To allow every module to initialize, even when single modules fail.
function initializeModuleSafely(initializer) {
  if (initializer == null || typeof initializer !== "function") {
    console.warn("Unable to start module, function expected");

    return;
  }

  try {
    initializer();
  } catch (e) {
    console.error("An unexpected error occured during module initialization", e);
  }
}

function sendBeacons() {
  if (('sendBeacon' in navigator) === false || typeof navigator.sendBeacon !== 'function') {
    return;
  }

  // Use in JS to avoid blocking source
  navigator.sendBeacon('https://hello.myfonts.net/count/3c7704');
}

function attachClickHandler() {
  $(document).on('click', 'a[href*="#"]', (e) => {
    e.preventDefault();

    const consentmanager = document.getElementById('cmpbox');

    if (consentmanager && window.getComputedStyle(consentmanager).display !== 'none') {
      return;
    }

    if (e.currentTarget.hash.indexOf("#/") === 0) {
      return;
    }

    if (e.target.closest('.nav-link')) {
      return;
    }

    if (e.target.classList.contains('kirinus-header__submenu-item')) {
      if (e.target.hasAttribute('aria-controls')) {
        return;
      }
    }

    if (String.prototype.trim.call(e.currentTarget.hash).length > 0 && !themeCommon.smoothScrollTo(e.currentTarget.hash, 750)) {
      window.location.href = e.currentTarget.href;
    }

    if (document.querySelector('.kirinus-header') && !e.target.classList.contains('kirinus-header__submenu-item') && !e.target.classList.contains('nav-item')) {
      console.log('KLommt rein');
      document.querySelectorAll('.kirinus-header .nav-link').forEach(item => {
        item.classList.remove('active');
      });

      if (document.querySelector('.kirinus-header .kirinus-header__submenu')) {
        document.querySelectorAll('.kirinus-header .kirinus-header__submenu').forEach(item => {
          item.classList.remove('active');
          setTimeout(() => {
            item.style.display = '';
          }, 500);
        });
      }

      if (document.querySelector('.kirinus-header .kirinus-header__submenu-item')) {
        document.querySelectorAll('.kirinus-header .kirinus-header__submenu-item').forEach(item => {
          item.classList.remove('active');
        });
      }

      if (document.querySelector('.kirinus-header .navbar-toggler').getAttribute('aria-expanded') === 'true') {
        document.querySelector('.kirinus-header .navbar-toggler').click();
      }
    }

    document.querySelector('body').classList.remove('overflow-hidden');
    document.querySelector('body').classList.remove('content-is-blur');
  });
}

// -------------------------------------------------------------------------------------------------
// Init app

initializePageloadRunner();

// Add explicit scrollbar width to html.
document.documentElement.style.setProperty(
  '--theme_scroll-width',
  `${window.innerWidth - document.documentElement.clientWidth}px`,
);

const componentLoaders = {
  domReady: [
    themeLazyBg.init,
    themeLazyImages.init,
    themePageHeader.init,
    themeContactIcon.init,
    themeHrlistSplit.init,
    initTextSwitch,
    themeContentHeader.init,
    themeContentWithSidebar.init,
    themeBigLeaf.init,
    themeSectorsSlider.init,
    themeTopicsCatalog.init,
    themeLocationsCatalog.init,
    themeSliderWithFilter.init,
    themeSliderCarousel.init,
    themeDropdownMenuNested.init,
    themeNavPillsOverflow.init,
    themePushdownNonSection.init,
    themeDropzone.init,
    LeafInfo.init,
    themePageHeaderSliderDisruptors.init,
    themeBlogAjax.init,
    themeBlogCategories.init,
    themeBlogHeader.init,
    themeTooltip.init,
    themeGallerySlider.init,
    themeWeeklyPlan.init,
    themeHideDateIcon.init,
    dateInputs.init,
    medatixx.init,
    datalayerTracking,
    linkSwitcher,
    applyHyphenation(),
    kirinusHeader(),
    digiAccess(),
    referFriends()
  ],
  load: [
    sendBeacons,
    themePageSearchModal.init,
    themeJumbo.init,
    themeLocationTour.init,
    themeLocationMap.init,
    themeStaffGrid.init,
    themeShareButton.init,
    themeFormSelect.init,
    themeContactForm.init,
    themeScrollIndicator.init,
    themeFloatingContactIcon.init,
    themeNewsListView.init,
    counterStatistic,
    themeVirtuelleTour.init,
    initializeTiles,
    initializeModalOverlays,
    themePetrolNavigation.init,
    attachClickHandler,
    themeDatepicker.init,
    themeFormSubmit.init,
    themeMultiStepForm.init,
    cookiesDatalayerTracking
    // themeInputError.init()
  ],
};

function startComponents(phase) {
  if (phase == null) {
    return Promise.allSettled(Object.keys(componentLoaders).map(x => startComponents(x)));
  }

  return new Promise((resolve, reject) => {
    if (Object.prototype.hasOwnProperty.call(componentLoaders, phase) === false) {
      return reject(`Unable to find phae ${phase} in compoent loaders`);
    }

    const initializers = componentLoaders[phase];
    setTimeout(() => {
      for (const initializer of initializers) {
        initializeModuleSafely(initializer);
      }

      resolve();
    });
  });
}

function attachDomReadyEvent() {
  window.addEventListener('DOMContentLoaded', async () => {
    await startComponents('domReady');
  }, {
    once: true,
  });
}

function attachLoadEvent() {
  window.addEventListener('load', async () => {
    await startComponents('load')
  }, {
    once: true,
  });
}

switch (document.readyState) {
  case 'loading':
    attachDomReadyEvent();
    attachLoadEvent();

    break;

  case 'interactive':
    attachLoadEvent();
    startComponents('domReady');

    break;

  case 'complete':
    startComponents();
}
